<template>
  <span v-if="counter.time" class="cart-counter-component">
    <img :src="ClockIcon" class="clock-icon" />
    <span class="font-bold text-4xl counter text-black dark:text-white">{{ counter.time }}</span>
  </span>
</template>

<script lang="ts" setup>
import { useCartTimerStore } from '~/store/cartTimerStore'
import ClockIcon from '~/assets/icons/timer_clock.svg'
const props = defineProps<{
  endTime: string
  refresh?: boolean
}>()

const cartTimer = useCartTimerStore()
// in seconds
const reservation = computed(() => (props.endTime ? Math.floor(new Date(props.endTime) - new Date()) / 1000 : 0))

onMounted(() => {
  cartTimer.start(reservation.value, props.refresh)
})

onUnmounted(() => {
  cartTimer.stop()
})

const counter = computed(() => cartTimer.getTime)
</script>

<style lang="postcss" scoped>
.cart-counter-component {
  @apply flex items-center gap-2 h-[2.0625rem] px-3 py-0;
  .counter {
    @apply flex min-w-28;
  }

  @media screen and (max-width: 420px) {
    .counter {
      @apply !text-[32px];
    }
  }
}
</style>
